<template>
  <v-app>
    <v-content>
      <v-container class="fill-height login" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-form ref="loginForm" @submit.prevent="login" lazy-validation>
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>Prihlásenie</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    type="text"
                    v-model="email"
                    label="Email"
                    name="login"
                    prepend-icon="mdi-account"
                    :rules="rules.email"
                  />

                  <v-text-field
                    type="password"
                    v-model="password"
                    label="Heslo"
                    name="password"
                    prepend-icon="mdi-lock"
                    :rules="rules.password"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn type="submit" color="primary">Prihlásiť</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <message></message>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config/app.config'
import { MessageService, MessageType } from '@/services/message'
import Message from '@/components/core/Message.vue'
import { Validator } from '@/utils/Validator'
import { AuthService } from '@/services/api/auth.service'

export default Vue.extend({
  components: {
    Message
  },

  data () {
    return {
      email: AppConfig.login.email,
      password: AppConfig.login.password,
      rules: {
        email: [
          Validator.required('Email')
        ],
        password: [
          Validator.required('Heslo')
        ]
      }
    }
  },

  methods: {
    login () {
      if (this.$refs.loginForm.validate()) {
        AuthService.login(this.email, this.password)
      }
    }
  }

})
</script>
